import styled from 'styled-components/macro';
import { FlexNoAlign } from '../../../../../shared-styles/flex';

export const ExpandControl = styled.div`
  ${FlexNoAlign}
  background-color: ${(props) => props.theme.palette.lightGray[50]};
  color: ${(props) => props.theme.palette.blue[100]};
  padding: ${(props) => props.theme.spacing(10)} ${(props) => props.theme.spacing(30)};
  :hover {
    color: ${(props) => props.theme.palette.darkBlue[100]};
    cursor: pointer;
  }
`;

export const Icon = styled.img`
  padding-right: ${(props) => props.theme.spacing(8)};
`;

export const ChildrenContainer = styled.div`
  flex-grow: 1;
  padding-left: ${(props) => props.theme.spacing(8)};
  margin-top: -3px;
`;

export const ExpandText = styled.p`
  padding-top: 3px;
`;
